import * as React from 'react';
import classnames from 'classnames';
import kebabCase from 'lodash/kebabCase';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';

import ContentCardAssetItem from './item/ContentCardAssetItem';

import { __t, applyTranslations } from 'utils/language';

import './content-card-asset.scss';

import type { ChannelTypes } from 'types';
import type {
  ContentCardItem
} from 'components/cards/content-card/types';

applyTranslations(require('components/cards/content-card/shared/content-card-shared.i18n.json'));

type Props = {
  item: ContentCardItem,
  index: number,
  channel: ChannelTypes,
  toggleStats: boolean,
  onToggleStats?: () => void,
  onNoPostClick?: () => void
};

const SHARED_MSG_KEY = 'content_card_shared';

const ContentCardAsset = ({
  item,
  index,
  channel,
  toggleStats,
  onToggleStats,
  onNoPostClick
}: Props): JSX.Element => {
  const containerClasses = classnames('content-card-asset', {
    [`content-card-asset--is-${kebabCase(item.type)}`]: Boolean(item.type)
  });

  const iconClasses = classnames('content-card-asset__icon', {
    'content-card-asset__icon--is-visible': !toggleStats
  });

  return (
    <div className={containerClasses}>
      <Tooltip
        message={__t(`${SHARED_MSG_KEY}.labels.show_details`)}
        width="auto-compact"
        forceHide={toggleStats}
        classNameWrapper={iconClasses}
        onClick={onToggleStats}
      >
        <SVGDynamicIcon
          name="equalizer-custom-bg"
          width={16}
          height={15}
          customColor="white"
          clickable
        />
      </Tooltip>
      <ContentCardAssetItem
        item={item}
        index={index}
        channel={channel}
        toggleStats={toggleStats}
        onNoPostClick={onNoPostClick}
      />
    </div>
  );
};

export default ContentCardAsset;
